export type GenerateFeedbackLinkArgs = {
  mailAddress: string | null | undefined;
  targetUrl: string;
};

export const generateFeedbackLink = (args: GenerateFeedbackLinkArgs) => {
  const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLSdUQeNzuCMr2EcMYjcOM5Ltc8HkPJdwo30jeMBbGhqV5BAJDQ/viewform?usp=pp_url";
  return `${formUrl}?usp=pp_url&entry.545727008=${args.mailAddress ?? ""}&entry.1701238580=${args.targetUrl}`;
};
